import { Box, Flex, Grid, GridItem, Heading, HStack, Link, StackProps, VStack } from "@chakra-ui/layout";
import { forwardRef, Image, Spinner, Text } from '@chakra-ui/react';
import { useMediaQuery } from "@chakra-ui/media-query";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import { baseUrl, generateBlogCategoryUrl } from "@core/paths";
import { omit } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Link as RouterLink } from "@reach/router";

enum WIDGET_TYPE {
  DESKTOP,
  MOBILE,
}

export const TwoRowsWidget = forwardRef<StackProps & {isDate?: boolean}, "div">(({
  firstCategory,
  secondCategory,
  mode,
                                                                                   isDate,
  ...rest
}: any, ref) => {
  const [isMobile, setIsMobile] = useState(false);
  const [mediaQuery] = useMediaQuery("(max-width: 48em)");
  const widgets = {
    [WIDGET_TYPE.DESKTOP]: () => (
      <Grid gap={{base: '12px', md: "32px"}} templateColumns={{ base: "100%", md: "47% 47%" }} mb="60px" justifyContent={{md: 'space-between'}}>
        <VStack alignItems="flex-start" spacing="32px">
          <Box as={RouterLink} to={generateBlogCategoryUrl(firstCategory.slug, firstCategory?.parent?.node?.slug)} cursor="pointer">
            <WidgetTitle color="#222C63">{firstCategory.name}</WidgetTitle>
          </Box>
          <Tile isDate={isDate} mode={ isMobile ? TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR_MOBILE : TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR} imageH="310px" w="100%" article={firstCategory.posts[0]} />
        </VStack>
        {secondCategory && (
          <VStack alignItems="flex-start" spacing="32px">
            <Box as={RouterLink} to={generateBlogCategoryUrl(secondCategory.slug, secondCategory?.parent?.node?.slug)} cursor="pointer">
              <WidgetTitle color="#222C63">{secondCategory.name}</WidgetTitle>
            </Box>
            <Grid templateColumns={{base: "repeat(1, 1fr)", md: "repeat(2, 1fr)"}} gridGap={{base: '12px', md: "32px"}}>
              {secondCategory.posts.slice(0, 4).map((post, i) => (
                <GridItem key={post.id}>
                  <Tile isDate={isDate} mode={i <= 1 ? TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR : TILE_MODES.SHORT_WITHOUT_THUMBNAIL} imageH="144px" article={post} />
                </GridItem>
              ))}
            </Grid>
          </VStack>
        )}
      </Grid>
    ),
    [WIDGET_TYPE.MOBILE]: () => (
      <>
        {firstCategory && mobileWidget(firstCategory)}
        {secondCategory && mobileWidget(secondCategory)}
      </>
    ),

  };

  const mobileWidget = (category) => (
    <VStack m="15px 0" gridGap="32px" alignItems="flex-start" >
      <Box as={RouterLink} to={generateBlogCategoryUrl(category.slug, category?.parent?.node?.slug)} cursor="pointer">
        <WidgetTitle color="#222C63">{category.name}</WidgetTitle>
      </Box>
      <Tile isDate={isDate} mode={ isMobile ? TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR_MOBILE : TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR} imageH="310px" w="100%" article={category.posts[0]} />
      {
        category.posts.length > 1 && (
          <Grid w="100%" templateColumns="repeat(1, 1fr)" gridGap="32px">
            {category.posts.slice(1, 5).map((post, i) => (
              <GridItem key={post.id}>
                <Tile isDate={isDate} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} imageH="144px" article={post} />
              </GridItem>
            ))}
          </Grid>
        )
      }

    </VStack>
  )



  useEffect(() => {
    if(mediaQuery !== isMobile) {
      setIsMobile(mediaQuery);
    }
  }, [mediaQuery]);

  const resultType = useMemo(() => {
    if (isMobile) {
      return WIDGET_TYPE.MOBILE;
    } else {
      return WIDGET_TYPE.DESKTOP
    }
  }, [isMobile]);


  return (
    <>
      {widgets[resultType]()}
      {/*<Grid gap="32px" templateColumns={{ base: "100%", md: "50% 50%" }} mb="60px" >*/}
      {/*  <VStack alignItems="flex-start" spacing="32px">*/}
      {/*    <WidgetTitle color="#222C63">{firstCategory.name}</WidgetTitle>*/}
      {/*    <Tile mode={ isMobile ? TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR_MOBILE : TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR} imageH="310px" w="100%" article={firstCategory.posts[0]} />*/}
      {/*  </VStack>*/}
      {/*  /!*{secondCategory && (*!/*/}
      {/*  /!*  <VStack alignItems="flex-start" spacing="32px">*!/*/}
      {/*  /!*    <WidgetTitle color="#222C63">{secondCategory.name}</WidgetTitle>*!/*/}
      {/*  /!*    <Grid templateColumns={{base: "repeat(1, 1fr)", md: "repeat(2, 1fr)"}} gridGap="32px">*!/*/}
      {/*  /!*      {secondCategory.posts.slice(0, 4).map((post, i) => (*!/*/}
      {/*  /!*        <GridItem>*!/*/}
      {/*  /!*          <Tile mode={i <= 1 ? TILE_MODES.SHORT_WITH_THUMBNAIL_WITH_AVATAR : TILE_MODES.SHORT_WITHOUT_THUMBNAIL} imageH="144px" article={post} />*!/*/}
      {/*  /!*        </GridItem>*!/*/}
      {/*  /!*      ))}*!/*/}
      {/*  /!*    </Grid>*!/*/}
      {/*  /!*  </VStack>*!/*/}
      {/*  /!*)}*!/*/}
      {/*</Grid>*/}
    </>

  )
});
